import { LoginWithKeycodeFormFieldValues } from "./types"
import { useFrontendConfig } from "../../../FrontendConfig"
import {
  AuthKeycodeCredentials, useLoginFetcher, useLoginService
} from "../../providers/LoginService"
import { useNavigationService } from "../../providers/NavigationService"
import { useTranslationsContext } from "../../providers/Translations"

export const useLoginWithKeycode = () => {
  const { persistLoginPreferences, storeCredentials, getAuthTokens } = useLoginService()
  const { redirectToApp, navigate } = useNavigationService()
  const { login, ...fetcher } = useLoginFetcher()
  const { Customer } = useFrontendConfig()
  const { language } = useTranslationsContext()

  const handleLogin = async ({ keycode, username }: LoginWithKeycodeFormFieldValues) => {
    try {
      const credentials: AuthKeycodeCredentials = {
        grant_type: "keycode",
        keycode,
        username: `${Customer}:${username}`,
        browser_token: getAuthTokens().browserToken
      }

      const { data } = await login(credentials)

      persistLoginPreferences({
        loggedInByKeycode: true, language
      })

      if (!data.require_twoFa) return redirectToApp(data)

      storeCredentials(credentials)
      navigate("/2fa")
    } catch (error) {
      console.error(error)
    }
  }

  return { handleLogin, ...fetcher }
}
